/*
 * configurateur-accordeon.js (v2)
 *
 * Transforme la barre d'étapes plate en accordéon à 4 sections.
 * v2 : classification par TITRE (textContent du pill) plus robuste que
 * par handle, car les handles Shopify peuvent varier (poignees vs poignee,
 * etc.). Log console pour debug.
 */

(function() {
  'use strict';

  var CATEGORIES = [
    { key: 'mon-style', title: 'Mon style' },
    { key: 'meubles', title: 'Meubles standards' },
    { key: 'sur-mesure', title: 'Sur mesure' },
    { key: 'finitions', title: 'Finitions et accessoires' }
  ];

  function normalizeText(s) {
    return (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  }

  function classifyPill(pill) {
    var handle = (pill.dataset.etape || '').toLowerCase();
    var text = normalizeText(pill.textContent);

    if (handle === 'personnalisation' || /^ma cuisine/.test(text)) return 'mon-style';

    if (/^luminaire/.test(text) || /^poignee/.test(text) || /^electro/.test(text) || /^accessoires/.test(text)) {
      return 'finitions';
    }
    if (/^(luminaire|poignee|poignees|electro|accessoires)/.test(handle)) {
      return 'finitions';
    }

    var sm = (window.mooodSurMesure || []).find(function(s) {
      return s.etapeHandle === handle;
    });
    if (sm && sm.type !== 'barre') return 'sur-mesure';

    if (/sur-?mesure/.test(handle)) return 'sur-mesure';

    return 'meubles';
  }

  function buildCategoriesUI() {
    var wrap = document.getElementById('moood-etapes');
    if (!wrap || wrap.dataset.categorized === '1') return;

    var pills = Array.prototype.slice.call(wrap.querySelectorAll('.moood-etape'));
    if (pills.length === 0) return;

    var debug = pills.map(function(p) {
      return {
        handle: p.dataset.etape,
        text: (p.textContent || '').trim(),
        innerHTML: p.innerHTML.substring(0, 80),
        category: classifyPill(p)
      };
    });
    console.log('[Accordéon moood] Classification :', debug);

    var groups = { 'mon-style': [], 'meubles': [], 'sur-mesure': [], 'finitions': [] };
    pills.forEach(function(p) {
      groups[classifyPill(p)].push(p);
    });

    var line = wrap.querySelector('.moood-etapes-line');
    if (line && line.parentNode) line.parentNode.removeChild(line);

    wrap.innerHTML = '';

    CATEGORIES.forEach(function(catDef) {
      var catPills = groups[catDef.key];
      if (!catPills.length) return;

      var cat = document.createElement('div');
      cat.className = 'moood-category';
      cat.dataset.categoryKey = catDef.key;

      var header = document.createElement('button');
      header.className = 'moood-category-header';
      header.type = 'button';
      header.setAttribute('aria-expanded', 'false');

      var headerLabel = document.createElement('span');
      headerLabel.className = 'moood-category-label';
      headerLabel.innerHTML =
        '<span class="moood-category-title">' + catDef.title + '</span>' +
        '<span class="moood-category-count"> &middot; ' + catPills.length +
        ' &eacute;tape' + (catPills.length > 1 ? 's' : '') + '</span>';

      var chev = document.createElement('span');
      chev.className = 'moood-category-chevron';
      chev.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="6 9 12 15 18 9"></polyline></svg>';

      header.appendChild(headerLabel);
      header.appendChild(chev);

      var body = document.createElement('div');
      body.className = 'moood-category-body';
      catPills.forEach(function(p) { body.appendChild(p); });

      cat.appendChild(header);
      cat.appendChild(body);

      header.addEventListener('click', function(e) {
        e.preventDefault();
        openCategory(cat);
      });

      wrap.appendChild(cat);
    });

    wrap.dataset.categorized = '1';

    refreshActiveCategory();
    setupActiveObserver();
  }

  function openCategory(cat) {
    if (cat.classList.contains('is-open')) return;
    var all = document.querySelectorAll('.moood-category');
    Array.prototype.forEach.call(all, function(c) {
      c.classList.remove('is-open');
      var h = c.querySelector('.moood-category-header');
      if (h) h.setAttribute('aria-expanded', 'false');
    });
    cat.classList.add('is-open');
    var h = cat.querySelector('.moood-category-header');
    if (h) h.setAttribute('aria-expanded', 'true');
  }

  function refreshActiveCategory() {
    var activePill = document.querySelector('.moood-etape.current') ||
                     document.querySelector('.moood-etape.active');
    if (!activePill) return;
    var cat = activePill.closest('.moood-category');
    if (!cat) return;

    var all = document.querySelectorAll('.moood-category');
    Array.prototype.forEach.call(all, function(c) {
      c.classList.remove('is-active');
      if (c !== cat) {
        c.classList.remove('is-open');
        var h = c.querySelector('.moood-category-header');
        if (h) h.setAttribute('aria-expanded', 'false');
      }
    });
    cat.classList.add('is-active', 'is-open');
    var h = cat.querySelector('.moood-category-header');
    if (h) h.setAttribute('aria-expanded', 'true');
  }

  function setupActiveObserver() {
    var pills = document.querySelectorAll('.moood-etape');
    var mo = new MutationObserver(function(muts) {
      var classChanged = muts.some(function(m) {
        return m.attributeName === 'class';
      });
      if (classChanged) refreshActiveCategory();
    });
    Array.prototype.forEach.call(pills, function(e) {
      mo.observe(e, { attributes: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildCategoriesUI);
  } else {
    buildCategoriesUI();
  }

  setTimeout(buildCategoriesUI, 300);
  setTimeout(buildCategoriesUI, 1000);

})();